import { DayOfWeek } from "@/types";

type Translator = {
  [key: string]: string;
};

export default function dayOfWeekTranslator(dayOfWeek: DayOfWeek) {
  const daysInPtbr: Translator = {
    MONDAY: "Segunda-feira",
    TUESDAY: "Terça-feira",
    WEDNESDAY: "Quarta-feira",
    THURSDAY: "Quinta-feira",
    FRIDAY: "Sexta-feira",
    SATURDAY: "Sábado",
    SUNDAY: "Domingo",
  };

  return daysInPtbr[dayOfWeek];
}
